import React from 'react';
import {IChannelIconProps} from './ChannelSuperIcon';

export const ChannelTextIcon: React.FC<IChannelIconProps> = ({className}) => (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="#B2B8BF"/>
        <path d="M11.1035 17H12.8955V8.796H15.6395V7.2H8.35945V8.796H11.1035V17Z" fill="#1F1F22"/>
    </svg>
);
